// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.audio-button-popper[data-v-1e7d1476] {\n  position: relative;\n}\n.popper[data-v-1e7d1476] {\n  background: rgba(24, 25, 27, 0.98);\n  border: 1px solid #43474f;\n  border-radius: 6px;\n  padding: 6px 16px;\n  white-space: nowrap;\n  width: auto;\n  z-index: 100;\n  text-align: center;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: white;\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
